import {useEffect, useRef, useState} from "react";

const useScrollSum = (MAX) => {
    const [scrollSum, setScrollSum] = useState(0);
    const lastTouchPosition = useRef(null);
    const decrementInterval = useRef(null)
    function handle(e){
        let deltaY = e.deltaY;
        if (!deltaY) {
            try {
                deltaY = lastTouchPosition.current - e.touches[0].screenY;
                lastTouchPosition.current = e.touches[0].screenY;
            } catch (error) {}
        }

        setScrollSum((s)=> {
            if(Math.abs(s) > MAX) return s;
            return deltaY + s
        });
    }

    function handleTouchStart(e){
        lastTouchPosition.current = e.touches[0].screenY;
    }

    const SPEED = 10
    const startDecrement = ()=>{
        if(decrementInterval.current) return;
        decrementInterval.current = setInterval(() => {
            setScrollSum((s) => {

                if (s > 0) {
                    return Math.max(s - SPEED, 0);
                } else if (s < 0) {
                    return Math.min(s + SPEED, 0);
                }
                return s;
            });
        }, 1000/ 20);
    }

    useEffect(() => {
        window.addEventListener("wheel", handle);
        window.addEventListener("touchstart", handleTouchStart);
        window.addEventListener("touchmove", handle);
        startDecrement();
        return () => {
            window.removeEventListener("wheel", handle);
            window.removeEventListener("touchstart", handleTouchStart);
            window.removeEventListener("touchmove", handle);
            if(decrementInterval.current) clearInterval(decrementInterval.current);
        };
    }, []);

    return [scrollSum, setScrollSum];
}

export default useScrollSum;